'use client'

import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import Link from 'next/link'

import ROUTES from 'config/routes.json'
import classes from 'containers/Layouts/Layout/Footer/styles.module.scss'
import content from 'prismic-translates/common.json'
import legalPages from 'prismic-translates/legal-pages.json'
import useCleanBackUrl from 'src/hooks/useCleanBackUrl'

const t = getTranslationFromJson([content, legalPages])

export const CookieConsentButtons = () => {
  const cleanBackUrl = useCleanBackUrl()

  return (
    <>
      <Link
        href={`${ROUTES.COOKIE_POLICY}?back=${encodeURIComponent(cleanBackUrl)}`}
        prefetch={false}
        className={classes.link}
        data-test='footer-cookie-policy'
      >
        {t('cookie_policy')}
      </Link>

      <Link
        href={`${ROUTES.RIGHT_TO_OPT_OUT}?back=${encodeURIComponent(cleanBackUrl)}`}
        prefetch={false}
        className={classes.link}
        data-test='footer-do-not-sell-or-share'
      >
        {t('do_not_sell_or_share')}
      </Link>

      <a
        id='ot-sdk-btn'
        className={`${classes.link}`}
        style={{ cursor: 'pointer' }}
        data-test='footer-your-privacy-choices'
        onClick={() => {
          // @ts-ignore
          if (window.OneTrust?.ToggleInfoDisplay) {
            // @ts-ignore
            window.OneTrust.ToggleInfoDisplay()
          } else {
            console.error('OneTrust is not available.')
          }
        }}
      >
        {t('cookie_settings')}
      </a>
    </>
  )
}
